<div id="demo" [innerHTML]="componentData.content"></div>